import React, { Component } from "react";
import cloneDeep from "lodash/cloneDeep";
import RegistrationCard from "../RegistrationCard";
import AddressForm from "./AddressForm";

class AddressPage extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(data) {
    const { onSubmit } = this.props;
    if (data.country.toLowerCase() === "other") {
      const clonedData = cloneDeep(data);
      clonedData.nextStep = "hunter-permit";
      onSubmit(clonedData);
    } else {
      onSubmit(data);
    }
  }

  render() {
    const { currentRegistration } = this.props;
    const { address, city, province, postal, country } = currentRegistration;
    // Address 2 is not required and therefore causes can result in an undefined
    // which causes problems with Firebase. We force it to null.
    let { address2 } = currentRegistration;
    address2 = address2 || null;

    return (
      <RegistrationCard
        title="Enter your address"
        subtitle="We use your address to help determine if you are eligible to use our shooting range."
        positiveActionLabel="Save & Continue"
      >
        <AddressForm
          onSubmit={this.handleSubmit}
          initialValues={{ address, address2, city, province, postal, country }}
        />
      </RegistrationCard>
    );
  }
}

AddressPage.propTypes = {};
AddressPage.defaultProps = {};

export default AddressPage;



// WEBPACK FOOTER //
// ./src/registration/components/Address/AddressPage.jsx